import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { filter, firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PermissionService } from '../services/permission.service';

/**
 * Builds a route guard that waits for the user's permissions to load and then applies `allowed`.
 * A user who fails the check is sent to the wizard, the one page everyone can see. With auth off
 * the guard passes immediately: authGuard never calls `PermissionService.load()` in that mode, so
 * `loaded` would stay false and the wait would hang the route forever.
 */
export function permissionGuard(allowed: (permissions: PermissionService) => boolean): CanActivateFn {
  return async () => {
    if (!environment.authEnabled) return true;

    const permissionService = inject(PermissionService);
    const router = inject(Router);

    await firstValueFrom(toObservable(permissionService.loaded).pipe(filter((loaded) => loaded)));

    if (allowed(permissionService)) return true;

    return router.createUrlTree(['/dashboard/rf-wizard']);
  };
}
